import classNames from 'classnames';
import React from 'react';
import { Icon } from '@udemy/icons';
import styles from "./lab-icon.module.css";
export const LabIcon = ({
  isCompleted = false
}) => {
  return /*#__PURE__*/React.createElement(Icon, {
    glyph: "labs",
    label: false,
    className: classNames(styles['lab-icon'], {
      [styles['completed']]: isCompleted
    })
  });
};
//# sourceMappingURL=lab-icon.react-component.js.map